export const PrimaryColor="#fde900";
export const SecondaryColor="#524d51";
export const WhiteColor="#fff";
export const BlackColor="#000";
export const LeftBubble="#fde900";
export const RightBubble="#fff";
export const ThemeBlue="#70c5c3";
export const TextColor="#707070";